// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-file[data-v-4d797a64] {\n\t\tposition: relative;\n\t\toverflow: hidden;\n}\n.btn-file input[type=file][data-v-4d797a64] {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tmin-width: 100%;\n\t\tmin-height: 100%;\n\t\tfont-size: 100px;\n\t\ttext-align: right;\n\t\tfilter: alpha(opacity=0);\n\t\topacity: 0;\n\t\toutline: none;\n\t\tbackground: white;\n\t\tcursor: inherit;\n\t\tdisplay: block;\n}\n", ""]);
// Exports
module.exports = exports;
